import { COLORS } from '@/styles/colorTheme';

interface ChipProps {
  color?: string;
  maxWidth?: string;
  py?: string;
  px?: string;
  selected?: boolean;
  children?: any;
  onClick?: (event: any) => void;
}

const Chip = ({
  color = COLORS.Background100,
  maxWidth,
  py = '12px',
  px = '12px',
  selected = false,
  children,
  onClick,
}: ChipProps) => {
  return (
    <div
      className={`rounded-lg px-3 py-2 cursor-pointer hover:bg-muted ${selected ? 'bg-muted' : ''}`}
      onClick={onClick}
    >
      <div className="text-sm text-text-400">{children}</div>
    </div>
  );
};

export default Chip;
